<script setup lang="ts">
    import { inject } from 'vue';
    import Tabs, { tab } from '@shared/components/Tabs.vue';
    import AddedSpeakers from '@views/Event/AddedSpeakers.vue';
    import Speakers from '@views/Event/Speakers.vue';
    import { handleAddSpeakerToEvent } from '@views/Event/SpeakersAndSponsorsListUtils';
    import { type Speaker } from '@views/Event/EventTypes';
    import { useEventMembers } from '@views/Event/EventEditor/use-event-members';
    import { canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    const props = defineProps<{
        eventId: string;
    }>();

    const canEdit = inject(canEditKey)!;

    const { state, customHeader, onLoaded, onAdded, onRemoved, onAddToEvent, onUpdateCustomHeader } = useEventMembers<Speaker>({
        eventId: () => props.eventId,
        idOf: (speaker) => speaker.SpeakerId,
        addToEvent: handleAddSpeakerToEvent,
        headerProperty: 'CustomSpeakerHeader',
        headerLabel: $Resources.EventSpeakersHeading,
    });
</script>

<template>
    <Tabs navClass="tabs list-unstyled">
        <tab :title="$Resources.SpeakerHeading">
            <AddedSpeakers
                :eventId="eventId"
                :addedSpeakers="state.added"
                :customSpeakerHeader="customHeader"
                :updateEnabled="canEdit"
                @addToEvent="onAddToEvent"
                @speakersLoaded="onLoaded"
                @speakerRemoved="onRemoved"
                @updateCustomSpeakerHeader="onUpdateCustomHeader"></AddedSpeakers>
        </tab>
        <tab :title="$Resources.AllSpeakersHeading">
            <Speakers
                :addToEvent="true"
                :eventId="eventId"
                :eventSpeakerIds="state.eventIds"
                :updateEnabled="canEdit"
                @speakerAdded="onAdded"></Speakers>
        </tab>
    </Tabs>
</template>
